// Inventory-only auth runtime flag.
//
// The shared pp_auth_token lives in sessionStorage (used by /outreach
// too) so a full refresh would normally keep the user signed in on
// /inventory. Per product spec, refreshing /inventory must always prompt
// the PIN again — but we must NOT log the user out of /outreach.
//
// Solution: an in-memory boolean scoped to the current JS runtime. On a
// hard refresh the module reloads and the flag resets to false, so
// InventoryAuthGate + InventoryPreview will bounce back to the PIN
// screen. sessionStorage keeps /outreach unlocked.
let unlocked = false;

export const markInventoryUnlocked = () => { unlocked = true; };
export const isInventoryUnlocked = () => unlocked;
export const clearInventoryUnlocked = () => { unlocked = false; };
